import { useVendaStatusObserver } from '../../common/hooks/useVendaStatusObserver';
import { navigateExternalNoReferrer } from '../../common/utils/navigate-no-referer';
import { emitFacebookEvent } from '../../common/utils/emit-facebook-event';
import { emitTikTokEvent } from '../../common/utils/emit-tiktok-event';
import { useEffect, useState } from 'react';
import { CreatePurchaseContract } from '../../common/types/create-purchase-contract';
import { Checkout } from '../../common/types/checkout';
import { useWebSocket } from '../../common/hooks/useWebSocket';
import { Sell } from '../../common/types/venda';
import { useLocation, useNavigate } from 'react-router-dom';
import { CarregarPagamento } from '../pages/carregar-pagamento/carregar-pagamento.page';
import { StatusVendaEnum } from '../../common/types/enums/status-venda.enum';
import { awaitEmitUtmifyEvent } from '../../common/utils/emitUtmifyEvent';

export const CarregarPagamentoTemplate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { socket } = useWebSocket();

  const [venda, setVenda] = useState<Sell>({} as Sell);
  const [checkout, setCheckout] = useState<Checkout>({} as Checkout);
  const [contract, setContract] = useState<CreatePurchaseContract>(
    {} as CreatePurchaseContract,
  );

  useEffect(() => {
    if (!location?.state?.purchase || !location?.state?.checkout) {
      window.location.href = 'https://vendepay.com.br/';
      return;
    }

    setVenda(location?.state?.purchase?.data);
    setCheckout(location?.state?.checkout);
    setContract(location?.state?.contract);
  }, [location.state]);

  useVendaStatusObserver({
    socket,
    vendaId: venda?.id,
    vendaToken: venda?.vendaToken,

    // mapeia o status do polling
    resolveFromStatus: (status) => {
      if (status === StatusVendaEnum.PAID) return 'success'; // PAGO
      if (
        status === StatusVendaEnum.FAILED ||
        status === StatusVendaEnum.CANCELED ||
        status === StatusVendaEnum.REFUSED
      )
        return 'failed'; // RECUSADO
      return null;
    },

    onResolved: ({ type, source }) => {
      console.log('[Venda resolvida]', type, 'via', source);

      const params = new URLSearchParams(location.search);
      if (venda?.id) {
        params.set('vendaId', venda.id);
        params.set('customerName', venda.nomeComprador);
        params.set('email', venda.emailComprador);
        params.set('phone', venda.telefoneComprador);
        params.set('productId', venda.produtoId);
      }

      if (type === 'success') {
        try {
          window?._uxa?.push?.([
            'track',
            'checkout_completed',
            { paymentStatus: 'success' },
          ]);
        } catch {}

        emitFacebookEvent({
          event: 'Purchase',
          checkout,
          data: contract,
        });
        emitTikTokEvent({
          event: 'Purchase',
          checkout,
          data: contract,
          orderId: venda?.id,
        });

        void (async () => {
          if (venda?.id) {
            await awaitEmitUtmifyEvent({
              event: 'paid',
              vendaId: venda.id,
            });
          }
          if (checkout?.paginaObrigado?.length) {
            navigateExternalNoReferrer(checkout.paginaObrigado, {
              newTab: false,
              extraParams: params,
            });
          } else {
            navigate(`/venda/obrigado?${params.toString()}`, {
              state: { ...venda, moedaOriginal: checkout.moeda, valorOriginal: checkout.subtotal },
            });
          }
        })();
      }

      if (type === 'failed') {
        try {
          window?._uxa?.push?.([
            'track',
            'checkout_completed',
            { paymentStatus: 'failed' },
          ]);
        } catch {}

        void (async () => {
          if (venda?.id) {
            await awaitEmitUtmifyEvent({
              event: 'refused',
              vendaId: venda.id,
            });
          }
          if (checkout?.pagamentoRecusado?.length) {
            navigateExternalNoReferrer(checkout.pagamentoRecusado, {
              newTab: false,
              extraParams: params,
            });
          } else {
            navigate(`/venda/compra-recusada/${venda.id}?${params.toString()}`, {
              state: { purchase: venda },
            });
          }
        })();
      }
    },
  });

  return <CarregarPagamento />;
};
